import { FileArrowDownIcon } from '@phosphor-icons/react';
import { useParams } from 'react-router-dom';

export default function PdfDownloadCard({ title, link, resourceType }) {
  const user = JSON.parse(localStorage.getItem('userProfile'));
  const { packId } = useParams();

  return (
    <div
      className="cursor-pointer flex flex-row border border-[var(--q3-stroke-normal)] rounded-xl items-center justify-between p-4"
      onClick={() => {
        window.webengage.track('Downloaded Resources', {
          'User Id': user?.email,
          'Pack Id': packId,
          'Resource Name': resourceType,
          'PDF Title': title,
        });
        window.open(link, '_blank');
      }}
    >
      <p className="font-medium">{title}</p>
      <FileArrowDownIcon size={24} className="text-[var(--q3-danger-normal)]" />
    </div>
  );
}
